import {Component} from '@angular/core';
import {FormService} from "../../services/form.service";
import {MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {Proposal} from "../../types/proposal";
import {FileUpload} from "primeng/fileupload";
import {HttpEventType} from "@angular/common/http";
import {AttachmentType} from "../../types/attachment-type";
import {Constants} from "../../types/constants";

@Component({
  selector: 'proposals-list',
  templateUrl: './proposals-list.component.html',
  styleUrls: ['./proposals-list.component.css']
})
export class ProposalsListComponent {
  proposals : Proposal[] = [];
  blockUI : boolean = false;

  constructor(private router: Router,
              private formService: FormService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.blockUI = false;
    this.formService.getDocuments()
    .subscribe(
      (response) => {
      if (response.body != null) {
        this.proposals = response.body;
      }
      },
    error => {
      this.proposals = [];
      if (error.status == 404)
        return;
      this.messageService.add({
        severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
        detail: error.error.message ?? Constants.GenericError }
      );
      }
    );
  }

  chooseForm(): void {
    this.router.navigate(['/choose-form']);
  }

  signProposal(proposal: Proposal) {
    this.formService.proposalSignature = proposal.docNo;
    this.formService.proposalId = proposal.id;
    this.formService.companyTypeId = proposal.companyTypeId;
    this.router.navigate(['/sign']);
  }

  uploadHandler(event: any, fileUpload: FileUpload, proposalId: number) {
    if (event.files[0] == undefined)
      return;

    fileUpload.disabled = true;
    this.blockUI = true;

    this.formService.uploadFile(event.files[0], proposalId, AttachmentType.DOCUMENT, undefined, undefined, undefined, "OTHER")
      .subscribe(
        event => {
          if (event.type === HttpEventType.Response) {
            fileUpload.clear();
            fileUpload.uploadedFileCount = 0;
            fileUpload.disabled = false;
            this.router.navigate(['proposal-signed']);
          }
        },
        error => {
          this.messageService.add({
            severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
            detail: error.error.message ?? Constants.GenericError}
          );
          fileUpload.clear();
          fileUpload.uploadedFileCount = 0;
          fileUpload.disabled = false;
          this.blockUI = false;
        }
      );
  }

  fileRemove(fileUpload: FileUpload) {
    fileUpload.uploadedFileCount = 0;
    fileUpload.disabled = false;
  }
}
